module.exports = __webpack_public_path__ + "img/ps-39.a709cc29.jpg";